<script lang="jsx">
const Checkbox = ({ key, id, label, checked, disabled, readonly, update, labelToLeft, bold, onChange}) => (
  <label class={{ checkbox: true, readonly }}>
    {!!labelToLeft && !!bold && <span><b>{label}</b></span>}
    {!!labelToLeft && !bold && <span>{label}</span>}
    <input
      key={key}
      id={id}
      type="checkbox"
      disabled={disabled}
      checked={checked}
      onclick={() => !readonly}
      onChange={e => onChange ? onChange(e.target.checked) : update(e.target.checked)}
    />
    {!labelToLeft && !bold &&<span>{label}</span>}
    {!labelToLeft && !!bold && <span><b>{label}</b></span>}
  </label>
);
export default Checkbox;
</script>

<style scoped>
.checkbox.readonly {
  opacity: 0.6;
  pointer-events: none;
}
</style>